import React, { useEffect, useState } from 'react';
import { api } from '@api';
import { Topbar, FreezeBalanceCard, } from '@components';
import { Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ContainerOutlined } from '@ant-design/icons';

const RootContainer = styled.div`
padding: 16px 16px 0 16px;
background: #fff;
`;

const Loader = styled.div`
  width: 100%;
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmptyBox = styled(Loader)`
flex-direction: column;
gap: 4px;

svg {
    color: #5D5189;
}
`;

const EmptyText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #5D5189;
`;

const FreezeBalances = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        getFreezeBalances();

        // eslint-disable-next-line
    }, []);

    const goBack = () => {
        navigate(`/${PUBLIC_ROUTE.HOME}`);
    };

    const getFreezeBalances = () => {
        setLoading(true);
        api
            .getFreezeBalances()
            .then(({ freeze_balances }) => {
                setLoading(false);
                setData(freeze_balances);
            })
            .catch((errorMsg) => {
                setLoading(false);
                message.error(errorMsg);
            });
    }

    const successCallback = (freeze_balance_id) => {
        setData(prev => prev.filter(item => item.freeze_balance_id !== freeze_balance_id));
    }

    const EmptyCard = () => (
        <EmptyBox>
            <ContainerOutlined />
            <EmptyText>
                {t("common.noRecord")}
            </EmptyText>
        </EmptyBox>
    );

    return (
        <>
            <Topbar title={t("freezeBalance.pageTitle")} goBack={goBack} />
            {loading
                ? <Loader><Spin /></Loader>
                : data.length === 0
                    ? <EmptyCard />
                    : (
                        <RootContainer>
                            {data.map((item, key) => (
                                <FreezeBalanceCard
                                    key={key}
                                    item={item}
                                    successCallback={successCallback}
                                />
                            ))}
                        </RootContainer>
                    )}
        </>
    );
}

export default FreezeBalances;